import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Question} from 'shared/models/questions/question';
import { QuestionChain } from 'shared/models/questions/question-chain';
import {Tiplist} from 'shared/models/tips/tiplist';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import { Jump } from '../interfaces/jump';
import * as Node from '../interfaces/node';

@Component({
  selector: 'modal-edit-node',
  templateUrl: './modal-edit-node.component.html',
  styleUrls: ['./modal-edit-node.component.css'],
})
export class ModalEditNodeComponent {
  @ViewChild('modal') private modal: any; // tslint:disable-line:no-any
  @Output() private confirm: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any
  @Output() private cancel: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any
  private questions: Array<Question> = [];
  public filteredQuestions: Array<Question> = [];
  public questionFieldsToSearch: Array<Array<string>> = [];
  private tipLists: Array<Tiplist>;
  public filteredTipLists: Array<Tiplist>;
  public tiplistFieldsToSearch: Array<Array<string>> = [];
  private jumps: Array<Jump>;
  public filteredJumps: Array<Jump>;
  public jumpFieldsToSearch: Array<Array<string>> = [];
  private nodeData: Node.Node;
  private selectedQuestion: {} = '';
  private selectedTipList: {} = '';
  private selectedJump: {} = '';
  public editType: string = 'Wählen...';
  public searchTerm: string;

  public show(): ModalEditNodeComponent {
    this.modal.show();
    return this;
  }

  public hide(): ModalEditNodeComponent {
    this.modal.hide();
    return this;
  }

  public setQuestions(questions: Array<Question>): ModalEditNodeComponent {
    this.questions = questions;
    this.prepareQuestionFieldsToSearch();
    return this;
  }

  public setTipLists(tipLists: Array<Tiplist>): ModalEditNodeComponent {
    this.tipLists = tipLists;
    this.prepareTiplistFieldsToSearch();
    return this;
  }

  public setJumps(jumps: Array<Jump>): ModalEditNodeComponent {
    this.jumps = jumps;
    this.prepareJumpFieldsToSearch();
    return this;
  }

  public setNodeData(nodeData: Node.Node): ModalEditNodeComponent {
    this.nodeData = nodeData;
    return this;
  }

  public doConfirm(data: Question | Tiplist | Jump): void {
    this.hide();
    if (Node.Tools.isQuestion(data)) {
      this.selectedQuestion = data;
    } else if (Node.Tools.isTiplist(data)) {
        this.selectedTipList = data;
    } else {
        this.selectedJump = data;
    }

    if (Node.Tools.isQuestion(data)) {
      this.nodeData.color = {
        border: '#2B7CE9',
        background: '#97C2FC',
        highlight: {
          border: '#2B7CE9',
          background: '#D2E5FF',
        },
      };
      this.nodeData.label = data.title.de;
      this.nodeData.data = data;
    } else if (Node.Tools.isTiplist(data)) {
      this.nodeData.color = {
        background: 'orange',
        border: 'rgba(221, 115, 115, 1)',
        highlight: {
          background: 'rgba(236, 202, 177, 1)',
          border: 'rgba(221, 115, 115, 1)',
        },
      };
      this.nodeData.label = data.title;
      this.nodeData.data = data;
    } else { // jump
      this.nodeData.color = {
        background: '#00B300',
        border: 'rgba(0, 102, 0, 1)',
        highlight: {
          background: 'rgba(0, 204, 0, 1)',
          border: 'rgba(51, 153, 51, 1)',
        },
      };
      this.nodeData.label = data.title.de;
      this.nodeData.data = data;
    }
    this.resetModal();
    this.confirm.emit(this.nodeData);
  }

  public doCancel(): void {
    this.hide();
    this.cancel.emit(null);
  }

  public filterQuestions(eventQuestions: Array<Question>): void {
    this.filteredQuestions = eventQuestions;
  }

  public filterTiplists(eventTiplists: Array<Tiplist>): void {
    this.filteredTipLists = eventTiplists;
  }

  public filterJumps(eventJumps: Array<Jump>): void {
    this.filteredJumps = eventJumps;
  }

  private resetModal(): void {
    this.selectedQuestion = '';
    this.selectedTipList = '';
    this.searchTerm = '';
    this.editType = 'Wählen...';
  }

  private prepareQuestionFieldsToSearch(): void {
    const result = [];
    this.questions.forEach((question) => {
      result.push([
        question.title.de.toLowerCase(),
      ]);
    });
    this.questionFieldsToSearch = [...result];
  }

  private prepareTiplistFieldsToSearch(): void {
    const result= [];
    this.tipLists.forEach((tiplist) => {
      result.push([
        tiplist.title.toLowerCase(),
      ]);
    });
    this.tiplistFieldsToSearch = [...result];
  }

  private prepareJumpFieldsToSearch(): void {
    const result = [];
    this.jumps.forEach((jump) => {
      result.push([
        jump.title.de.toLowerCase(),
      ]);
    });
    this.jumpFieldsToSearch = [...result];
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/modal-edit-node/modal-edit-node.component.ts